"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isBlank(str) {
    return str === '' || str.trim() === '';
}
exports.default = isBlank;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNCbGFuay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pc0JsYW5rLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsU0FBd0IsT0FBTyxDQUFDLEdBQVc7SUFDekMsT0FBTyxHQUFHLEtBQUssRUFBRSxJQUFJLEdBQUcsQ0FBQyxJQUFJLEVBQUUsS0FBSyxFQUFFLENBQUM7QUFDekMsQ0FBQztBQUZELDBCQUVDIn0=